export const formatTypeMap = {
  300: 'SVG',
  301: 'HTML',
  302: 'HTML',
  500: 'HTML',
};

export const typeToName = {
  300: 'name',
  302: 'cellRange',
  301: 'namedRange',
  500: 'groupName',
};

export const upperCaseNames = {
  300: ['uniqueId', 'worksheetName', 'chartName'],
  301: ['uniqueId', 'worksheetName'],
  302: ['uniqueId', 'worksheetName'],
  500: [],
};
